function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrending(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "300pt",
    viewBox: "30 170 300 300.99927",
    width: "300pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "white"
    },
    d: "m261.257812 253.167969h-64.265624c-8.285157 0-15 6.714843-15 14.996093-.003907 8.285157 6.714843 15.003907 14.996093 15.003907h28.058594l-64.085937 64.082031-34.835938-34.835938c-5.855469-5.855468-15.355469-5.855468-21.210938 0l-34.085937 34.082032c-5.859375 5.859375-5.859375 15.355468-.003906 21.214844 5.859375 5.859374 15.355469 5.855468 21.214843 0l23.480469-23.476563 34.832031 34.835937c2.8125 2.8125 6.628907 4.394532 10.609376 4.394532 3.976562 0 7.792968-1.582032 10.605468-4.394532l74.691406-74.6875v28.050782c0 8.28125 6.714844 15 15 15 8.285157 0 15-6.71875 15-15v-64.265625c0-8.285157-6.714843-15-15-15zm0 0"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrending);
export default __webpack_public_path__ + "static/media/trending.6da7b1c9.svg";
export { ForwardRef as ReactComponent };